import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import Subject from '@/components/subject.vue';
import ReviewData from '@/views/review/components/review-data/index.vue';
import OtherReview from '@/views/review/components/other-review.vue';
import CardList from '@/views/review/components/card-list/index.vue';
import Filing from '@/components/filing.vue';
import OutlineCache from '@/utils/OutlineCache.js';
import { queryReviewPlan as _queryReviewPlan } from '@/api/review.js';
export default {
  name: 'Review',
  components: {
    Subject: Subject,
    ReviewData: ReviewData,
    OtherReview: OtherReview,
    CardList: CardList,
    Filing: Filing
  },
  data: function data() {
    return {
      edu: JSON.parse(localStorage.getItem('userInfo')).edu,
      // 学段
      subjectCode: 0,
      // 学科
      taskId: null,
      // 任务id
      totalData: {},
      // 今日复习数据
      errorTextUrl: '',
      // 错题本跳转页面
      reviewNoteUrl: '' // 笔记复习跳转页面

    };
  },
  computed: _objectSpread({}, mapGetters(['subjectGetters', 'studyBindSuccess', 'closeCodeDialog'])),
  watch: {
    subjectGetters: {
      handler: function handler(val) {
        this.subjectCode = +val;
        this.switchSubject(val);
      }
    },
    studyBindSuccess: function studyBindSuccess() {
      // 绑定自学宝
      this.init();
    },
    closeCodeDialog: function closeCodeDialog(val) {
      val && this.init(); // 输入激活码
    }
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              window.onpageshow = function (event) {
                // 开始复习退出后刷新页面
                if (event.persisted) {
                  window.location.reload();
                }
              };

              _this.cache = OutlineCache.getInstance();
              _this.subjectCode = +_this.subjectGetters || _this.cache.getCurrentSubject(_this.edu);
              _context.next = 5;
              return _this.queryReviewPlan();

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    init: function init() {
      window.location.reload(); // 绑定自学宝后刷新学科
    },
    // 切换学科
    switchSubject: function switchSubject(subjectCode) {
      if (this.subjectCode !== subjectCode) {
        this.subjectCode = subjectCode;
        this.cache.switchSubject(this.edu, subjectCode, true);
        this.$store.dispatch('setSubject', subjectCode);
        this.queryReviewPlan();
      }
    },
    // 今日复习计划
    queryReviewPlan: function queryReviewPlan() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$_queryReviewPl, status, data, taskId, errorTextUrl, reviewNoteUrl;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _queryReviewPlan({
                  subjectId: _this2.subjectCode
                });

              case 2:
                _yield$_queryReviewPl = _context2.sent;
                status = _yield$_queryReviewPl.status;
                data = _yield$_queryReviewPl.data;

                if (!(status !== 1)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return");

              case 7:
                taskId = data.taskId, errorTextUrl = data.errorTextUrl, reviewNoteUrl = data.reviewNoteUrl;
                _this2.totalData = data;
                _this2.taskId = taskId;
                _this2.errorTextUrl = errorTextUrl;
                _this2.reviewNoteUrl = reviewNoteUrl;

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 关闭批量处理&卡片弹窗后更新数据
    updateData: function updateData() {
      this.queryReviewPlan();
      this.$refs.subject.init();
      this.$refs.reviewData.queryMemoryCardInfo();
    }
  }
};